import React from 'react';
import {
  Flex,
  Text,
  VStack
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

function getDisplayValue(value, type) {
  switch (type) {
    case 'boolean':
      return String(!!parseInt(value, 10));
    case 'monetary':
      return `$${Number(parseInt(value, 10).toFixed(1)).toLocaleString()}`;
    default:
      return value.toString();
  }
}

const InsuranceRequirementsCell = ({ value: insuranceRequirement }) => (
  <VStack fontSize="13px" key={insuranceRequirement?.id}>
    {
        insuranceRequirement?.properties?.filter(p => p.value > 0).map(property => (
          <Flex alignItems="flex-end" justifyContent="space-between" key={property.name} width="100%">
            <Text mr={4}>{property.displayName || property.type?.displayName}</Text>
            <Text>{getDisplayValue(property.value, property.dataType || property.type?.dataType)}</Text>
          </Flex>
        ))
      }
  </VStack>
);

InsuranceRequirementsCell.propTypes = { value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]) };

export default InsuranceRequirementsCell;
